import * as React from 'react';

type IconSegmentoSuperProps = React.SVGProps<SVGSVGElement>;

export const IconSegmentoSuper: React.FC<IconSegmentoSuperProps> = (props) => (
	<svg
		width={28}
		height={24}
		viewBox="0 0 28 24"
		fill="#BBC2C7"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<path d="M26.002 4.86563L23.3161 0.614063C23.077 0.234375 22.6505 0 22.1958 0H5.47077C5.01608 0 4.58952 0.234375 4.35046 0.614063L1.65983 4.86563C0.272333 7.05938 1.50046 10.1109 4.09265 10.4625C4.28015 10.4859 4.47233 10.5 4.65983 10.5C5.88327 10.5 6.97077 9.96562 7.71608 9.14062C8.4614 9.96562 9.5489 10.5 10.7723 10.5C11.9958 10.5 13.0833 9.96562 13.8286 9.14062C14.5739 9.96562 15.6614 10.5 16.8848 10.5C18.113 10.5 19.1958 9.96562 19.9411 9.14062C20.6911 9.96562 21.7739 10.5 22.9973 10.5C23.1895 10.5 23.377 10.4859 23.5645 10.4625C26.1661 10.1156 27.3989 7.06406 26.0067 4.86563H26.002ZM23.7567 11.9484H23.752C23.5036 11.9812 23.2505 12 22.9926 12C22.4114 12 21.8536 11.9109 21.3333 11.7516V18H6.33327V11.7469C5.80827 11.9109 5.24577 12 4.66452 12C4.40671 12 4.1489 11.9812 3.90046 11.9484H3.89577C3.70358 11.9203 3.51608 11.8875 3.33327 11.8406V18V21C3.33327 22.6547 4.67858 24 6.33327 24H21.3333C22.988 24 24.3333 22.6547 24.3333 21V18V11.8406C24.1458 11.8875 23.9583 11.925 23.7567 11.9484Z" />
	</svg>
);
